module.exports = __webpack_public_path__ + "static/media/lamina20img.3d2a9a01.png";